export default __webpack_public_path__ + "static/media/mobile-app-banner-bg.4afa7c3a.jpg";